/*
 * currentNumberOfDays reducer
 */
import { SET_CURRENT_NUMBER_OF_DAYS } from './constants';

type State = ?number;

type Action = {
    +type: string,
    +payload: Object
};

const initialState = null;

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case SET_CURRENT_NUMBER_OF_DAYS:
            return action.payload.numberOfDays;
        default:
            return state;
    }
}
